export default "__VITE_PUBLIC_ASSET__9cb6804e__"